/* 🤖 this file was generated by svg-to-ts */
export const iconLinea: {
  name: 'linea';
  data: string;
} = {
  name: 'linea',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><path fill="#83DBFA" d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16"/><path fill="#121212" d="M21.23 24.33H7.99V10.38h3.03v11.25h10.21zm0-11.25c1.49 0 2.7-1.21 2.7-2.7s-1.21-2.7-2.7-2.7-2.7 1.21-2.7 2.7 1.21 2.7 2.7 2.7"/></svg>`,
};
